import Swiper from 'swiper'

import { select } from '@js/util/select.js'
import { shuffle } from '@js/util/helpers.js'
import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus.js'

select('.testimonials-swiper', testimonialElement => {
  const swiperElement = testimonialElement.querySelector('.swiper')
  const swiperWrapperElement = swiperElement.querySelector('.swiper-wrapper')

  // Shuffle slides (if not inside viewport)
  const rect = testimonialElement.getBoundingClientRect()
  if (
    (rect.top < 0 || rect.top > window.innerHeight) &&
    (rect.bottom < 0 || rect.bottom > window.innerHeight)
  ) {
    const elements = shuffle([...swiperWrapperElement.children])
    for (let element of elements) {
      swiperWrapperElement.appendChild(element)
    }
  }

  let swiper = new Swiper(swiperElement, {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    autoHeight: true,
    speed: 600,
    slidesPerGroupAuto: true,

    // Don't set threshold to 0 as this can cause scrolling issues in iOS
    threshold: 15,
  })

  // Keyboard focus is not handled by Swiper.js itself
  swiperHandleKeyboardFocus(swiper)

  // Handle previous button
  function onPrevClick() {
    swiper.slideTo(swiper.activeIndex - 1)
  }
  let prevButton = testimonialElement.querySelector('.custom-button-prev')
  prevButton?.addEventListener('click', onPrevClick)

  // Handle next button
  function onNextClick() {
    // swiper.slideTo(swiper.activeIndex + 1)
    swiper.slideNext()
  }
  let nextButton = testimonialElement.querySelector('.custom-button-next')
  nextButton?.addEventListener('click', onNextClick)

  // Handle swiper destroy
  swiper.once('beforeDestroy', () => {
    prevButton?.removeEventListener('click', onPrevClick)
    nextButton?.removeEventListener('click', onNextClick)
  })

  testimonialElement.style.setProperty('--quote-height', `var(--height-${swiper.realIndex})`)
  swiper.on('activeIndexChange', () => {
    testimonialElement.style.setProperty('--quote-height', `var(--height-${swiper.realIndex})`)
  })

  return () => {
    swiper.destroy()
  }
})
